export const lightModeColors = {
  primary: "#F1F1F3",
  secondary: "#19181C",
  selected: "#DDEBF8",
  brand: "#201B41",
  backgroundSubtle: "#F1F1F3",
  backgroundBrand: "#DFDCF1",
  gray: "#F5F5F5",
  lightGray: "#F5F5F5",
  border: "#d9d9f0",
  lightBlue: "#DDEBF8",
  rowA: "#F1F1F3",
  rowB: "#e1e1e1",
  red: "#BF1234",
  success: "#339E65",
  darkGray: "#737373",
};

export const darkModeColors = {
  primary: "#19181C",
  secondary: "#F1F1F3",
  selected: "#201B41",
  brand: "#242428",
  backgroundSubtle: "#242428",
  backgroundBrand: "#DFDCF1",
  gray: "#19181C",
  lightGray: "#BCBBC3",
  border: "#4A4852",
  lightBlue: "#DDEBF8",
  rowA: "#404040",
  rowB: "#616161",
  red: "#BF1234",
  success: "#339E65",
  darkGray: "#737373",
};
